import {flatMap, get, groupBy, map, pick, toLower, trim, sortBy} from 'lodash';
import BaseService from '../../middleware/BaseService';

const SEARCH_ENDPOINT = '/search/autocomplete/drivername';
const TERMINALS_ENDPOINT = '/terminals';

class ReportFiltersService extends BaseService {
  prefix = SEARCH_ENDPOINT;

  sortByName = list => sortBy(list, it => trim(toLower(get(it, 'name'))));

  async loadTerminals() {
    const response = await this.search({deleted: false}, TERMINALS_ENDPOINT);

    const terminals = map(get(response, 'data', []), item => {
      const {region, id, name} = item;
      const terminal = {id, name};
      if (region) {
        terminal.parentGroupId = region;
        terminal.parentGroupName = region;
      } else {
        terminal.parentGroupId = '0';
        terminal.parentGroupName = 'All Terminals';
      }
      return terminal;
    });

    const sortedList = this.sortByName(terminals, 'name');
    const groupedList = groupBy(sortedList, 'parentGroupId');
    return flatMap(groupedList, (value, key) => {
      const sorted = this.sortByName(value);
      if (key !== '0') {
        return {id: key, name: key, root: true, children: map(sorted, it => pick(it, 'id', 'name'))};
      }
      return map(sorted, it => pick(it, 'id', 'name'));
    });
  }

  async predict(params) {
    if (!params || !params.text) {
      return [];
    }

    const response = await this.search(params, SEARCH_ENDPOINT);
    return map(get(response, 'data', []), e => ({
      id: e.id || e.name,
      name: e.name,
      number: e.number,
      type: e.type
    }));
  }
}
export default new ReportFiltersService();
